/**
 * Sticky CTA — mobile bottom bar
 *
 * Panel z buttonem przypięty do dołu ekranu na mobile.
 * Pojawia się dopiero po przewinięciu poza element [data-sticky-cta-start]
 * (sekcja 2 — button „weź udział w konkursie").
 * Chowa się gdy [data-sticky-cta-anchor] (sekcja 3 — button „Weź udział")
 * wejdzie w widoczny obszar viewportu.
 */

(function () {
  'use strict';

  var stickyBar = document.getElementById('contest-sticky-cta');
  var startTrigger = document.querySelector('[data-sticky-cta-start]');
  var endAnchor = document.querySelector('[data-sticky-cta-anchor]');

  if (!stickyBar || !startTrigger || !endAnchor) return;

  // Start hidden
  stickyBar.classList.add('is-hidden');

  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;

    window.requestAnimationFrame(function () {
      var startRect = startTrigger.getBoundingClientRect();
      var endRect = endAnchor.getBoundingClientRect();

      // Show: start trigger has scrolled above the viewport
      var pastStart = startRect.bottom <= 0;
      // Hide: end anchor has entered the viewport
      var reachedEnd = endRect.top <= window.innerHeight;

      if (pastStart && !reachedEnd) {
        stickyBar.classList.remove('is-hidden');
      } else {
        stickyBar.classList.add('is-hidden');
      }

      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // Initial state check
  onScroll();
})();
